import Box from '@mui/material/Box';

const LaunchSoon = () => {
    return <Box component="h3"
        sx={{ textAlign: 'center', fontSize: '1.75rem', fontWeight: 'normal', color: '#FF5C00'}}
    >Coming Soon..</Box>
}

export default LaunchSoon;
